module.exports = __webpack_public_path__ + "static/media/sel-personaje-404.8dce2f57.gif";